import { find } from 'lodash';

export const storeActions = (setState, getState) => ({
  onAddAnsweredConcept: (nodeId, concept) => {
    const { concepts } = getState();

    const conceptsForNode = find(concepts, ['nodeId', nodeId]);
    const selectedConceptId = concept.id.toString();

    if (!conceptsForNode) {
      setState({
        concepts: [
          ...concepts,
          {
            nodeId,
            conceptIds: [concept.refId],
            conceptBackEndIds: [selectedConceptId],
          },
        ],
      });

      return;
    }

    if (!conceptsForNode.conceptIds.includes(concept.refId)) {
      const newConcepts = concepts.map((item) => {
        if (item.nodeId === nodeId) {
          return {
            ...item,
            conceptIds: [...item.conceptIds, concept.refId],
            conceptBackEndIds: [...item.conceptBackEndIds, selectedConceptId],
          };
        }

        return item;
      });

      setState({ concepts: newConcepts });
    }
  },

  onAddAnsweredChoiceSet: (nodeId, choiceSetId, blockId) => {
    const { choiceSetBlocks, choiceSetBlockIds } = getState();

    if (!choiceSetBlockIds.includes(blockId)) {
      setState({
        choiceSetBlockIds: [...choiceSetBlockIds, blockId],
      });
    }

    const choiceSetBlocksForNode = find(choiceSetBlocks, ['nodeId', nodeId]);

    if (!choiceSetBlocksForNode) {
      setState({
        choiceSetBlocks: [
          ...choiceSetBlocks,
          {
            nodeId,
            choiceSetIds: [choiceSetId],
          },
        ],
      });

      return;
    }

    if (!choiceSetBlocksForNode.choiceSetIds.includes(choiceSetId)) {
      const newChoiceSetBlocks = choiceSetBlocks.map((item) => {
        if (item.nodeId === nodeId) {
          return {
            ...item,
            choiceSetIds: [...item.choiceSetIds, choiceSetId],
          };
        }

        return item;
      });

      setState({ choiceSetBlocks: newChoiceSetBlocks });
    }
  },

  // exampleAsync: async () => {
  //   await new Promise((resolve) => setTimeout(resolve, 1000));
  //   const state = getState();
  //   setState({ count: state.count + state.multiplier });
  // },
});
